export const TOGGLE_YEAR = 'TOGGLE_YEAR';
export const SELECT_MONTH = 'SELECT_MONTH';
export const CANCEL_SELECTED_MONTH = 'CANCEL_SELECTED_MONTH';
export const SELECT_SIMILAR_EXRATE_MONTHS = 'SELECT_SIMILAR_EXRATE_MONTHS';

export const toggleSelectedYear = (selectedYear) => ({
  type: TOGGLE_YEAR,
  payload: selectedYear,
});

export const selectMonth = (selectedMonth) => ({
  type: SELECT_MONTH,
  payload: selectedMonth,
});

export const cancelSelectedMonth = () => ({
  type: CANCEL_SELECTED_MONTH,
});

export const selectSimilarExRateMonths = (rate) => ({
  type: SELECT_SIMILAR_EXRATE_MONTHS,
  payload: rate,
});



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/